export default "__VITE_ASSET__EHs$xRms__"